import { CommerceService } from "@/services/commerce"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const mutationDeleteCustomerCart = {
  async deleteCustomerCart(parent, args, context, info) {
    let { customerId, customerKey, cartId, cartKey } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.DELETE,
    })
    const commerceApi = CommerceService.api()

    if (typeof customerId !== "string" && typeof customerKey !== "string") return null
    if (typeof cartId !== "string" && typeof cartKey !== "string") return null

    const isCustomerKey = typeof customerKey === "string"
    const isCartKey = typeof cartKey === "string"

    let customer = {}

    // get customer
    if (isCustomerKey) customer = (await commerceApi.customers().withKey({ key: customerKey }).get().execute())?.body
    else customer = (await commerceApi.customers().withId({ ID: customerId }).get().execute())?.body

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    // get all customer carts
    let customerCart =
      (
        await commerceApi
          .carts()
          .get({ queryArgs: { where: `customerId="${customer.id}"` } })
          .execute()
      ).body?.results || []

    customerCart = isCartKey
      ? customerCart.filter((cart) => cart.key === cartKey)
      : customerCart.filter((cart) => cart.id === cartId)

    customerCart = customerCart instanceof Array ? customerCart[0] : null

    if (!customerCart) return null

    const deletedCart = (
      await commerceApi
        .carts()
        .withId({ ID: customerCart.id })
        .delete({ queryArgs: { version: customerCart.version } })
        .execute()
    ).body

    return deletedCart
  },
}
